import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import toggleRegisterForm from '../../store/actions/registerFormToggle';
import RegisterForm from './RegisterForm';
import closeIcon from '../../assets/icons/closeIcon.svg';
import LoginForm from './LoginForm';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

function AuthModal() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { translations } = useSelector((state) => state.translation);
  const { visible, type } = useSelector((state) => state.registerToggle);
  const navigate = useNavigate();
  const [method, setMethod] = useState('Sign Up');
  const lang = Cookies.get('i18next') || 'en';
  // const { translations } = useSelector((state) => state.translation);
  const handleCloseModal = () => {
    dispatch(toggleRegisterForm({ visible: false, type }));
  };
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [visible]);
  useEffect(() => {
    if (type === 'login') {
      setMethod('Login');
    } else if (type === 'register') {
      setMethod('Sign Up');
    } else if (type === 'forgot') {
      setMethod('Forgot Password');
    } else if (type === 'reset') {
      setMethod('Reset Password');
    }
  }, [type]);
  const handleGetBack = () => {
    if (type === 'reset') {
      dispatch(toggleRegisterForm({ visible: false, type: 'register' }));
      navigate(`/${lang}`);
    } else {
      dispatch(toggleRegisterForm({ visible: true, type: 'login' }));
    }
  };
  return (
    <Dialog
      dismissableMask
      closeIcon={() => <img src={closeIcon} alt="close icon" />}
      draggable={false}
      modal
      header=""
      className="register-modal"
      maskStyle={{
        background: 'rgba(0, 0, 0, 0.60)',
      }}
      visible={visible}
      onHide={() => { if (!visible) return; handleCloseModal(); }}
    >
      <div className="register-modal-content">
        <div className="register-modal-content_top">
          {(type === 'forgot' || type === 'reset') ? (
            <button onClick={handleGetBack} type="button" className="auth-modal-btn-back">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M11.25 14.25L6.75 9L11.25 3.75"
                  stroke="#4C5965"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p>{translations.back[lang]}</p>
            </button>
          ) : <p className="register-modal-content_top_wellcome">{t('welcome')}</p>}
          <p className="register-modal-content_top_method">{t(method)}</p>
          {type === 'forgot' && <p className="auth-modal-forgot-text">{t('send__password-reset-link')}</p>}
        </div>
        <div>
          {/* eslint-disable-next-line no-nested-ternary */}
          {type === 'register' ? (
            <RegisterForm type={type} />
          // eslint-disable-next-line no-nested-ternary
          ) : type === 'forgot' ? (
            <ForgotPassword type={type} />
          ) : type === 'reset' ? (<ResetPassword />) : (
            <LoginForm type={type} />
          )}
        </div>

      </div>
    </Dialog>
  );
}

export default AuthModal;
